export function imageIsNonFallbackPlaceholder(imageUrl) {
    return imageUrl.match(/(passenger|suv_AT|suv_HT|suv_MT|litruck|truck)/);
}